export function formatPriceINR(value) {
  if (!value && value !== 0) return "";

  const num = Number(value);

  if (num >= 1_00_00_000) {
    // Crores
    return `₹ ${(num / 1_00_00_000).toFixed(2).replace(/\.00$/, '')}Cr`;
  }

  if (num >= 1_00_000) {
    // Lakhs
    return `₹ ${(num / 1_00_000).toFixed(2).replace(/\.00$/, '')}L`;
  }

  if (num >= 1_000) {
    // Thousands (optional)
    return `₹ ${(num / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
  }

  return `₹ ${num}`;
}